import { Expose } from "class-transformer";
import { IsOptional, IsString } from "class-validator";

export class ServiceTypeIcon {
  @IsOptional()
  @IsString()
  @Expose()
  code!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  icon!: string | null;
}
